import Select from "../../../../common/core-ui/Select.tsx";
import {
  locales,
  useCurrentVstLocale,
} from "../../../../common/utils/locale.ts";
import { useIntl } from "react-intl";
import { useFetcher } from "react-router-dom";

interface LanguagePickerProps {
  className?: string;
}

export default function LanguagePicker({ className }: LanguagePickerProps) {
  const intl = useIntl();
  const currentLocale = useCurrentVstLocale();
  const fetcher = useFetcher();

  return (
    <fetcher.Form
      action="/actions/user"
      method="post"
      onChange={(e) => fetcher.submit(e.currentTarget)}
    >
      <Select
        label={intl.formatMessage({ defaultMessage: "Select Language" })}
        className={className}
        defaultValue={currentLocale}
        name="locale"
      >
        {Object.entries(locales).map(([localeName, localeData]) => (
          <option value={localeData.vstFormat} key={localeName}>
            {localeData.label}
          </option>
        ))}
      </Select>
    </fetcher.Form>
  );
}
